import React, { useState } from 'react';
import '@css/TrashButton.css'; // Ensure this CSS file is properly imported

function TrashButton({ onDelete, buttonText = 'Delete' }) {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = () => {
    if (!isDeleting) {
      setIsDeleting(true);
      setTimeout(() => {
        setIsDeleting(false);
        onDelete && onDelete(); // Call the delete function after animation
      }, 2500); // Time aligns with animation duration
    }
  };

  return (
    <button
      className={`button ${isDeleting ? 'delete' : ''}`}
      onClick={handleDelete}
    >
      <div className='trash'>
        <div className='top'>
          <div className='paper'></div>
        </div>
        <div className='box'></div>
        <div className='check'>
          <svg viewBox='0 0 8 6'>
            <polyline points='1 3.4 2.71428571 5 7 1'></polyline>
          </svg>
        </div>
      </div>
      <span>{buttonText}</span>
    </button>
  );
}

export default TrashButton;
